var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86692 0.609959C1.51978 0.262826 0.95697 0.262826 0.609837 0.609959C0.262704 0.957092 0.262704 1.51991 0.609837 1.86704L5.74294 7.00014L0.60989 12.1332C0.262757 12.4803 0.262757 13.0431 0.60989 13.3903C0.957023 13.7374 1.51984 13.7374 1.86697 13.3903L7.00001 8.25722L12.1331 13.3903C12.4802 13.7374 13.043 13.7374 13.3901 13.3903C13.7373 13.0431 13.7373 12.4803 13.3901 12.1332L8.25709 7.00014L13.3902 1.86704C13.7373 1.51991 13.7373 0.957092 13.3902 0.609959C13.0431 0.262826 12.4802 0.262826 12.1331 0.609959L7.00001 5.74306L1.86692 0.609959Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose2);
export default __webpack_public_path__ + "static/media/icon-close-2.cf4243c68224005b416fad4fc3338dc0.svg";
export { ForwardRef as ReactComponent };